module.exports = __webpack_public_path__ + "cab81fdd0fcbba8dc14e2c37d5f77b9d.png";